import { render } from "./FreeLabel.vue?vue&type=template&id=ea4ee8d0"
import script from "./FreeLabel.vue?vue&type=script&lang=js"
export * from "./FreeLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__